import * as THREE from "three";
import getPosInfo from "./getPosInfo";


const modelSetY = async (model) => {

    const bboxModel = getPosInfo(model);
    model.position.y += bboxModel.ySize / 2;
    model.updateMatrix();

    return model;
}
export default modelSetY;
